import React from 'react';
import { Outlet } from 'react-router-dom';

import Footer from './partials/Footer';
import Header from './partials/Header';

export default function App() {
  const showHeader = window.location.pathname !== '/docs/fileUpload';
  return (
    <div>
      { showHeader && <Header /> }
      <div className={`${showHeader? " pt-28 md:pt-12" : ""}`}><Outlet /></div>
      <Footer />
    </div>
  );
};